import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  DialogContent,
  Typography,
  Grid,
  Select,
  MenuItem,
  FormControl,
  Box,
} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import InputMask from "react-input-mask";

import generator from "generate-password";
import { RoleService } from "../../../services/role.service";
import { SiteService } from "../../../services/site.service";
import { connect } from "react-redux";
import { actions } from "../../../redux/actions/alert";

const useStyles = makeStyles((theme) => ({
  form: {
    width: "auto", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  label: {
    marginBottom: "1.5vh",
  },

  // TODO MOVE TO GLOBAL STYLES
  formControl: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("md")]: {
      width: 180,
    },
    [theme.breakpoints.down("sm")]: {
      width: 250,
    },
    minWidth: 200,
    width: 320,
  },
  box: {
    marginTop: "20px",
  },
}));

const EmployeeForm = ({
  addAlert,
  detailAlert,
  openModal,
  userCreated,
  closeDialog,
}) => {
  const classes = useStyles();
  const [user, setUser] = React.useState({});
  const [roleArray, setRoleArray] = React.useState([]);
  const [siteArray, setSiteArray] = React.useState([]);
  const [showPassword, setShowPassword] = React.useState(true);

  useEffect(() => {
    (async function () {
      addAlert({ showAlert: false });
      try {
        const roleResponse = await RoleService.getRoles();
        const siteResponse = await SiteService.getSites();
        setRoleArray(roleResponse.data);
        setSiteArray(siteResponse.data);
      } catch (error) {
        console.log(error);
        closeDialog();
        addAlert({ showAlert: true });
        detailAlert({ severity: "error", message: error.msgs });
      }
    })();
  }, []);

  useEffect(() => {
    if (user.name) {
      userCreated("create", user);
      closeDialog();
    }
  }, [user]);

  const handleInputText = ({ target: { name, value } }) => {
    if (name === "roleId" && value === 1) {
      setUser({ ...user, [name]: value, siteId: 1 });
    } else setUser({ ...user, [name]: value });
  };

  const generatePassw = () => {
    const password = generator.generate({
      length: 10,
      numbers: true,
      uppercase: false,
    });
    setUser({ ...user, password });
  };

  const handleSubmitForm = (event) => {
    addAlert({ showAlert: false });
    event.preventDefault();
    if (roleArray.length === 0) {
      addAlert({ showAlert: true });
      detailAlert({
        severity: "warning",
        message:
          "Es necesario crear al menos una rol para poder guardar un usuario",
      });
      return;
    }
    if (siteArray.length === 0) {
      console.log(siteArray);
      addAlert({ showAlert: true });
      detailAlert({
        severity: "warning",
        message:
          "Es necesario crear al menos una sucursal para poder guardar un usuario",
      });
      return;
    }

    if (!user.siteId) {
      addAlert({ showAlert: true });
      detailAlert({
        severity: "warning",
        message: "Es necesario asociar al usuario a una sucursal",
      });
      return;
    }

    const name = `${user.firstName} ${user.lastName}`;
    setUser({ ...user, name });
  };

  const resetForm = () => {
    setUser({
      ...user,
      firstName: "",
      lastName: "",
      telephone: "",
      password: "",
      email: "",
      roleId: "",
      siteId: "",
    });
  };

  return (
    <React.Fragment>
      <DialogContent>
        <ValidatorForm
          noValidate
          className={classes.form}
          method="POST"
          onSubmit={handleSubmitForm}
          onError={(errors) => console.log(errors)}
        >
          <Grid
            container
            direction="row"
            justify="space-around"
            alignItems="center"
          >
            <Grid item xs={12} sm={6} md={6} lg={5} xl={5}>
              <Box mb={4}>
                <Typography
                  component={"span"}
                  variant="h5"
                  style={{ color: "#0b148e" }}
                >
                  Nuevo Empleado
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={5} xl={5}></Grid>
            <Grid item xs={12} sm={6} md={6} lg={5} xl={5}>
              <Box className={classes.box}>
                <Typography
                  variant="body2"
                  component={"div"}
                  className={classes.label}
                >
                  Nombre(s)
                </Typography>
                <TextValidator
                  className={classes.inputField}
                  name="firstName"
                  value={user.firstName || ""}
                  validators={["required"]}
                  onChange={(e) => handleInputText(e)}
                  errorMessages={["El nombre es requerido"]}
                  variant="outlined"
                  inputProps={{
                    maxLength: 35,
                  }}
                ></TextValidator>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={5} xl={5}>
              <Box className={classes.box}>
                <Typography
                  variant="body2"
                  component={"div"}
                  className={classes.label}
                >
                  Apellido(s)
                </Typography>
                <TextValidator
                  className={classes.inputField}
                  name="lastName"
                  value={user.lastName || ""}
                  validators={["required"]}
                  onChange={(e) => handleInputText(e)}
                  errorMessages={["El apellido es requerido"]}
                  variant="outlined"
                  inputProps={{
                    maxLength: 35,
                  }}
                ></TextValidator>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={5} xl={5}>
              <Box className={classes.box}>
                <Typography
                  variant="body2"
                  component={"div"}
                  className={classes.label}
                >
                  Teléfono
                </Typography>
                <InputMask
                  mask="9999999999"
                  maskChar=""
                  value={user.telephone || ""}
                  onChange={(e) => handleInputText(e)}
                >
                  {() => (
                    <TextValidator
                      className={classes.inputField}
                      name="telephone"
                      validators={["required"]}
                      errorMessages={["El teléfono es requerido"]}
                      variant="outlined"
                    ></TextValidator>
                  )}
                </InputMask>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={5} xl={5}>
              <Box className={classes.box}>
                <Typography
                  variant="body2"
                  component={"div"}
                  className={classes.label}
                >
                  Email
                </Typography>
                <TextValidator
                  className={classes.inputField}
                  name="email"
                  autoComplete="off"
                  value={user.email || ""}
                  validators={["required", "isEmail"]}
                  onChange={(e) => handleInputText(e)}
                  errorMessages={[
                    "El email es requerido",
                    "Formato de email incorrecto",
                  ]}
                  variant="outlined"
                  inputProps={{
                    maxLength: 40,
                  }}
                ></TextValidator>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={5} xl={5}>
              <Box>
                <FormControl variant="outlined" className={classes.formControl}>
                  <Typography
                    variant="body2"
                    component={"div"}
                    className={classes.label}
                  >
                    Rol
                  </Typography>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="roleId"
                    required
                    value={user.roleId || ""}
                    onChange={(e) => handleInputText(e)}
                  >
                    {roleArray.map((role, id) => {
                      return (
                        <MenuItem key={id} value={role.id}>
                          {role.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={5} xl={5}>
              <Box>
                <FormControl variant="outlined" className={classes.formControl}>
                  <Typography
                    variant="body2"
                    component={"div"}
                    className={classes.label}
                  >
                    Sucursal asignada
                  </Typography>
                  {/**TODO disabled si el usuario === admin */}
                  <Select
                    disabled={user.roleId === 1}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="siteId"
                    value={user.siteId || ""}
                    onChange={(e) => handleInputText(e)}
                  >
                    {siteArray.map((site, id) => {
                      return (
                        <MenuItem key={id} value={site.id}>
                          {site.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={5} xl={5}>
              <Button
                variant="contained"
                size="small"
                onClick={generatePassw}
                style={{ margin: "4vh 1vh", fontSize: 12 }}
              >
                Generar contraseña
              </Button>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={5} xl={5}>
              <TextValidator
                name="password"
                size="small"
                type={showPassword ? "text" : "password"}
                value={user.password || ""}
                validators={["required"]}
                onChange={(e) => handleInputText(e)}
                errorMessages={["El password es requerido"]}
                variant="outlined"
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword(!showPassword)}
                        onMouseDown={(event) => event.preventDefault()}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              ></TextValidator>
            </Grid>
          </Grid>

          <Grid
            style={{ marginTop: 30 }}
            container
            direction="row"
            justify="center"
            alignItems="center"
          >
            <Grid item>
              <Button
                color="primary"
                style={{ marginRight: 50, width: 150 }}
                onClick={() => {
                  closeDialog();
                  resetForm();
                }}
              >
                Cancelar
              </Button>
            </Grid>
            <Grid item>
              <Button
                color="primary"
                style={{ width: 150 }}
                variant="contained"
                type="submit"
              >
                Guardar
              </Button>
            </Grid>
          </Grid>
        </ValidatorForm>
      </DialogContent>
    </React.Fragment>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(undefined, dispatch)(EmployeeForm);
